import styled from '@emotion/styled'
import { Card, Row, Col } from 'react-bootstrap'
import { PrimaryButton } from '@mmsg/louie'
import InformationBlock from '@mmsg/louie/dist/InformationBlock/InformationBlock' // why?

export const EstimateItemStyled = styled.div`
  label: EstimateItemStyled;
  .estimate-item {
    max-width: 404px;
    display: inline-block;
    margin: 2px;
    border: 1px solid ${(props) => props.theme.colors.borderColor};
    border-radius: 4px;
    .car-image {
      text-align: center;
      img {
        width: 280px;
        height: 169px;
      }
      > svg {
        max-width: 280px;
        width: 100%;
        height: auto;
      }
    }
    .btn.bg-brand {
      border-radius: 40px;
    }

    .row-spacing {
      padding: 12px 0;
    }
    .card-header {
      padding: 9px 16px;
      border-bottom: none;
      position: relative;
    }
    .btn.btn-view-details {
      width: 179px;
      padding: 12px;
    }
    h2 {
      font-weight: bold;
      font-size: 32px;
    }
    .txt-header {
      padding: 12px;
      background: ${(props) => props.theme.colors.primaryLightText};
    }
  }

  .highlight {
    border: 1px solid ${(props) => props.theme.colors.primary};
    border-radius: 3px;
  }
  .spartaHighlight {
    border-color: ${(props) => props.theme.colors.spartaGreen};
  }
`
export const EstimateItemPrimaryButton = styled(PrimaryButton)`
  label: EstimateItemPrimaryButton;
  background: ${(props) =>
    props.isSparta
      ? props.theme.colors.spartaGreen
      : props.theme.colors.primary} !important;
  border-color: ${(props) =>
    props.isSparta
      ? props.theme.colors.spartaGreen
      : props.theme.colors.primary} !important;
  &:hover {
    background: ${(props) =>
      props.isSparta
        ? props.theme.colors.positive2
        : props.theme.colors.primaryButtonHover} !important;
    border-color: ${(props) =>
      props.isSparta
        ? props.theme.colors.positive2
        : props.theme.colors.primaryButtonHover} !important;
  }
`
export const EstimateItemInfoBlock = styled(InformationBlock)`
  label: EstimateItemInfoBlock;
  > div > div:nth-child(1) {
    color: ${(props) =>
      props.isSparta
        ? props.theme.colors.alertGreen
        : props.theme.colors.primary};
  }
  > div > div:nth-child(2) {
    color: ${(props) =>
      props.theme.brand == 'Maxxia'
        ? props.theme.colors.grey2
        : props.theme.colors.textDarkblack};
  }
`
export const CardHeader = styled(Card.Header)`
  label: CardHeaderStyled;
  padding: 9px 16px;
  background: ${(props) =>
    props.invalid
      ? props.theme.colors.lightBackground
      : props.theme.brand == 'Maxxia'
      ? props.theme.colors.primary
      : props.theme.colors.secondary};
  color: ${(props) =>
    props.invalid ? props.theme.colors.textLightblack : 'white'};
  font-weight: 900;
  border-bottom: none;
  position: relative;
  border-radius: 3px 3px 0 0 !important;
  text-align: center;
`

export const SpartaCardHeader = styled(CardHeader)`
  label: SpartaCardHeader;
  background: ${(props) =>
    props.invalid
      ? props.theme.colors.lightBackground
      : props.theme.colors.alertGreen};
`
export const SpartaBlock = styled.div`
  label: SpartaBlock;
  position: absolute;
  bottom: 0;
  width: 250px;
  left: 50%;
  transform: translateX(-50%);
`
export const ImageText = styled.div`
  label: ImageText;
  text-align: center;
  margin: 15px 0px;
  color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const CarName = styled.h3`
  label: CarName;
  min-height: ${(props) => props.headerHeight};
  word-break: break-word;
  font-size: ${(props) => (props.theme.brand == 'Maxxia' ? '24px' : '34px')};
  font-weight: ${(props) => (props.theme.brand == 'Maxxia' ? 700 : 800)};
  color: ${(props) =>
    props.theme.brand == 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
`

export const ListContainer = styled.div`
  label: ListContainer;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  border-radius: 4px;
  max-width: 1140px;
  padding: 9px;
  margin: 0 auto;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  position: absolute;
  height: 51px;
  top: -40px;
`

export const HideBox = styled('div')`
  label: HideBox;
  display: flex;
  z-index: 1;
  align-items: baseline;
  > div:first-child {
    cursor: pointer;
    > div {
      display: flex;
      align-items: center;
    }
  }
`

export const CarousalNav = styled('div')`
  label: CarousalNav;
  display: flex;
  justify-content: end;
  align-items: center;
`

export const NavCount = styled('div')`
  label: NavCount;
  display: flex;
  align-items: center;
  margin-right: 12px;
`
export const NavButton = styled('button')`
  label: NavButton;
  border: none;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  background: none;
  padding: 0;
`

export const TickList = styled('ul')`
  label: TickList;
  list-style-image: url(/images/maxxia-tick.svg);
  padding-left: 25px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  margin-bottom: 15px;
`

export const WhiteHeading = styled('h2')`
  label: WhiteHeading;
  margin-top: 80px;
  font-size: 20px;
`

export const BannerText = styled.div`
  label: BannerText;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 800;
  margin-top: 15px;
  width: 80%;
  text-align: left;
`

export const DisclaimerDiv = styled.div`
  label: DisclaimerDiv;
  margin: 15px 0px;
  text-align: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'left' : 'center'};
  font-weight: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.font.weight.normal
      : props.theme.font.weight.slightBold};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.navColor
      : props.theme.colors.textDarkblack};
`

export const LeaseInfoRow = styled.div`
  label: LeaseInfoRow;
  display: flex;
  justify-content: space-between;
  padding: 12px 0px;
`

export const LeaseInfoTitle = styled.div`
  label: LeaseInfoTitle;
  max-width: 45%;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.theme.brand === 'Maxxia' ? 400 : props.theme.font.weight.slightBold};
`

export const LeaseInfoValue = styled.div`
  label: LeaseInfoValue;
  text-align: right;
  word-break: normal;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.theme.brand === 'Maxxia' ? 700 : props.theme.font.weight.normal};
`

export const LeaseTermDiv = styled.div`
  label: LeaseTermDiv;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
  padding: 12px 0px;
  > div {
    font-weight: ${(props) =>
      props.theme.brand === 'Maxxia'
        ? props.theme.font.weight.normal
        : props.theme.font.weight.semiBold};
  }
  > h2 {
    font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '32px' : '34px')};
    font-weight: ${(props) =>
      props.theme.brand === 'Maxxia'
        ? props.theme.font.weight.normal
        : '800 !important'};
  }
`

export const TotalSalPackBlock = styled.div`
  label: TotalSalPackBlock;
  padding: 12px;
  background: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.backgrounds.backGround3
      : null};
  border-radius: 0.25rem !important;
  box-sizing: border-box;
  margin: 1rem 0rem;
`

export const TotalSalPackTitle = styled.div`
  label: TotalSalPackTitle;
  color: ${(props) => props.theme.colors.primary};
  font-weight: ${(props) =>
    props.theme.brand === 'Maxxia' ? props.theme.font.weight.normal : 900};
`

export const TotalSalPackText = styled.div`
  label: TotalSalPackText;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
  margin: 12px 0px;
`

export const EstOutOfPocket = styled.div`
  label: EstOutOfPocket;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? '#003D79'
      : props.theme.colors.primary};
  font-weight: ${(props) => props.theme.font.weight.bold};
  margin-bottom: 12px;
`

export const EstSavingsBlock = styled.div`
  label: EstSavingsBlock;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  text-align: center;
  margin: 12px 0px;

  > h2 {
    font-size: ${(props) =>
      props.theme.brand === 'Maxxia' ? '32px' : '34px !important'};
    font-weight: ${(props) =>
      props.theme.brand === 'Maxxia' ? 'bold' : '800 !important'};
  }
`

export const OnRoadBudgetBlock = styled.div`
  label: OnRoadBudgetBlock;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const OnRoadTextItem = styled.div`
  label: OnRoadTextItem;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
  font-weight: ${(props) =>
    props.isBold ? 800 : props.theme.font.weight.normal};
  font-size: ${(props) => (props.isBig ? '34px' : '18px')};
  margin-bottom: ${(props) => (props.isPadded ? '15px' : '0px')};
`

export const ColouredBlock = styled.div`
    label: ColouredBlock;
    text-align: center;
    margin: 0 auto;
    color: #fff !important;
    padding: 12px 16px;
    border-radius: 6px;
    max-width: 213px;
    font-size: ${(props) => props.theme.font.caption.fontSize};
    background: ${(props) => props.theme.brand === 'Maxxia' ? '#003D79' : '#3CB387'};
`
